import EmployeeDailyTimescan from '@/api/employee-daily-timescan'
import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  department_id: [],
  branch_id: [],
  position_id: [],
  att_status: ['Present'],
  status: [],
  staff_id: [],
  dataAttendances: [],
  type: '',
  date_from: moment().format('DD-MM-YYYY'),
  date_to: moment().format('DD-MM-YYYY')
}

export const getters = {
  tConvert: () => time => {
    if (time === null || time === undefined) return null
    // Check correct time format and split into components
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time]

    if (time.length > 1) {
      // If time format correct
      time = time.slice(1) // Remove full string match value
      time[5] = +time[0] < 12 ? ' AM' : ' PM' // Set AM/PM
      time[0] = +time[0] % 12 || 12 // Adjust hours
    }
    return time.join('') // return adjusted time or original string
  }
}

export const mutations = {
  ...baseMutations,
  SET_DATE_FROM(state, data) {
    state.date_from = data
  },
  SET_DATE_TO(state, data) {
    state.date_to = data
  },
  SET_DEPARTMENT_ID(state, data) {
    state.department_id = data
  },
  SET_BRANCH_ID(state, data) {
    state.branch_id = data
  },
  SET_EMPLOYEE_ID(state, data) {
    state.staff_id = data
  },
  SET_POSITION_ID(state, data) {
    state.position_id = data
  },
  SET_STATUS_ID(state, data) {
    state.att_status = data
  },
  SET_EMPLOYEE_STATUS(state, data) {
    state.status = data
  },
  SET_ATTENDANCE(state, data) {
    state.dataAttendances = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        date_from: context.state.date_from,
        date_to: context.state.date_to,
        department_id: context.state.department_id,
        staff_id: context.state.staff_id,
      },
      attributes
    )
    return EmployeeDailyTimescan.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  fetchAttendance(context, attributes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        date_from: context.state.date_from,
        date_to: context.state.date_to,
        department_id: context.state.department_id,
        staff_id: context.state.staff_id,
      },
      attributes
    )
    return EmployeeDailyTimescan.get({ params }).then(response => {
      context.commit('SET_ATTENDANCE', response.data)
      return Promise.resolve(response)
    })
  },
  getDepartment(context, data) {
    return EmployeeDailyTimescan.department(data);
  },

  getBranch(context, data) {
    return EmployeeDailyTimescan.branch(data);
  },

  getEmployee(context, data) {
    return EmployeeDailyTimescan.employee(data);
  },

  getPosition(context, data) {
    return EmployeeDailyTimescan.position(data);
  },

  getEmployeeStatus(context, data) {
    return EmployeeDailyTimescan.employeeStatus(data);
  },

  // Export Excel
  exportExcel(context, data) {
    data = {
      date_from: context.state.date_from,
      date_to: context.state.date_to,
      department_id: context.state.department_id,
      position_id: context.state.position_id,
      att_status: context.state.att_status,
      status: context.state.status,
      branch_id: context.state.branch_id,
      staff_id: context.state.staff_id,
      type: data.type,
    }
    return EmployeeDailyTimescan.exportExcel(data)
  },
}
